import { NatureFrais, type ModeFrais } from '../shared'

export const NatureFraisAvecQuantite: Readonly<NatureFrais[]> = [] as const
export type NatureFraisAvecQuantite = (typeof NatureFraisAvecQuantite)[number]

export const NatureFraisAnnexe = ['Hebergement', 'Repas', 'Transport'] as const

export const NatureFraisPedagogique = ['Pedagogique', 'JuryFraisCertification', 'Autres', 'LivrableOfa'] as const

export const NaturesFrais: { [key in ModeFrais]: Readonly<NatureFrais[]> } = {
  Annexe: NatureFraisAnnexe,
  Pedagogique: NatureFraisPedagogique,
}

export const HelpFraisPedagogique: { [key in NatureFrais]?: string } = {
  Pedagogique: 'Formation, évaluation, accompagnement',
} as const

export const HelpFraisAnnexe: { [key in NatureFrais]?: string } = {} as const
